var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19L0.674681 0.250002L22.3253 0.25L11.5 19Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon1);
export default __webpack_public_path__ + "static/media/Polygon 1.131d7508a4bb8a6ff1445ea96e470963.svg";
export { ForwardRef as ReactComponent };